export const PNP_DEPOSIT_ERROR_POPUP_KEY = 'fabric:pnp-deposit-error-popup';

export type PnpDepositErrorPopupPayload = {
  amount: string;
  currency: string;
  timestamp: string;
};

export const setPnpDepositErrorPopup = (payload: PnpDepositErrorPopupPayload) => {
  try {
    localStorage.setItem(PNP_DEPOSIT_ERROR_POPUP_KEY, JSON.stringify(payload));
  } catch (error) {
    console?.error('Failed to set pnp deposit error popup:', error);
  }
};
